import React, { useRef, useState } from "react";
import Button from "../../../components/UI/Button/Button";

import { Camera, CameraType } from 'react-camera-pro';

import styles from './PhotoReader.module.css';
import { IconCamera, IconCameraRotate, IconImages, IconXmark, IconFolderOpen } from '../../../components/UI/Icons/Icons';

const isMobile = () =>
  typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches;

const readFile = (file, onLoad) => {
  const reader = new FileReader();
  reader.onload = (ev) => onLoad(ev.target.result);
  reader.readAsDataURL(file);
};

const NativePhotoReader = (props) => {
  const cameraInputRef = useRef(null);
  const libraryInputRef = useRef(null);
  const [facing, setFacing] = useState('environment');

  const onFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) readFile(file, props.onTrigger);
  };

  const toggleFacing = () =>
    setFacing(f => f === 'environment' ? 'user' : 'environment');

  return (
    <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <input ref={cameraInputRef} type="file" accept="image/*" capture={facing}
             style={{ display: 'none' }} onChange={onFileChange} />
      <input ref={libraryInputRef} type="file" accept="image/*"
             style={{ display: 'none' }} onChange={onFileChange} />
      <Button onClick={() => cameraInputRef.current?.click()}><IconCamera /> Foto aufnehmen</Button>
      <Button style={{ margin: '10px auto' } } onClick={toggleFacing}>
        <IconCameraRotate /> {facing === 'environment' ? 'Frontkamera' : 'Rückkamera'}
      </Button>
      <Button onClick={() => libraryInputRef.current?.click()}><IconImages /> Aus Fotobibliothek</Button>
      <Button onClick={props.onCancel}><IconXmark /> Abbrechen</Button>
    </div>
  );
};

const DesktopPhotoReader = (props) => {
  const [numberOfCameras, setNumberOfCameras] = useState(0);
  const camera = useRef(null);
  const fileInputRef = useRef(null);

  const onTrigger = () => {
    if (camera.current) {
      const photo = camera.current.takePhoto();
      props.onTrigger(photo);
    }
  };

  const onCameraSelect = () => {
    if (camera.current) {
      camera.current.switchCamera();
    }
  };

  const onFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) readFile(file, props.onTrigger);
  };

  return (
    <>
      <input ref={fileInputRef} type="file" accept="image/*"
             style={{ display: 'none' }} onChange={onFileChange} />
      <div className={styles.wrapper}>
        <Camera ref={camera}
                aspectRatio="cover"
                numberOfCamerasCallback={setNumberOfCameras}
                facingMode="environment"
        />
        <div className={styles.control}>
          <button className={styles.cancel_button}
                  onClick={props.onCancel}
          />
          <button className={styles.take_photo_button}
                  onClick={onTrigger}
          />
          <button className={styles.change_facing_camera_button}
                disabled={numberOfCameras <= 1}
                onClick={onCameraSelect}
          />
          <button className={styles.folder_button}
                  onClick={() => fileInputRef.current?.click()}
          />
        </div>
      </div>
    </>
  );
};

const PhotoReader = (props) => {
  return isMobile()
    ? <NativePhotoReader {...props} />
    : <DesktopPhotoReader {...props} />;
};

export default PhotoReader;
